'use client';
import React from 'react';
import ExecutiveMobileHome from './components/ExecutiveMobileHome';

export default function ExecutiveMobilePage() {
  return <ExecutiveMobileHome data-component-id="src\app\executive-mobile\page.tsx:6:9" data-component-path="src\app\executive-mobile\page.tsx" data-component-line="6" data-component-end-line="6" data-component-file="page.tsx" data-component-name="ExecutiveMobileHome" data-component-content="%7B%22elementName%22%3A%22ExecutiveMobileHome%22%7D" />;
}
